import { fetchFile } from '../lib/utils';
import { ClientConfig } from '../types/ClientConfig';
import { ADMIN_API_URL, getHeaders } from './BaseClient';

export const AdminClient = (config: ClientConfig) => {
    const { accessToken } = config;
    const headers = getHeaders(accessToken);

    const getScoreExport = (quarter: string, year: string): Promise<any> => {
        const apiUrl = `${ADMIN_API_URL}/export/?quarter=${quarter}&year=${year}`;

        return fetchFile(apiUrl, {
            headers,
        });
    };

    const getManagementReport = (quarter: string, year: string): Promise<any> => {
        const apiUrl = `${ADMIN_API_URL}/managementreport/?quarter=${quarter}&year=${year}`;

        return fetchFile(apiUrl, {
            headers,
        });
    }

    const uploadFile = (file: File): Promise<any> => {
        const apiUrl = `${ADMIN_API_URL}/uploadfile`;

        // TODO: Do cleanup
        // https://stackoverflow.com/a/35206069
        // The Content-Type header is set to multipart/form-data by the browser removing it is necessary
        // If the header is not removed the browser won't set the file boundaries correctly
        // @ts-ignore
        delete headers['Content-Type'];
        var formData= new FormData()
        formData.append('file', file)
        return fetch(apiUrl, {
            method: 'POST',
            headers,
            body: formData,
        });
    }

    return {
        getScoreExport,
        uploadFile,
        getManagementReport
    };
};
